import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Watch, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FAQ_NAMESPACE } from '../../store/modules/faq/faq.store.js';
import { store } from '../../store/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const faqModule = namespace(FAQ_NAMESPACE);
let FaqHeaderComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.searchText = this.value;
  }
  destroyed() {
    this.setSearchText("");
  }
  updateSearchText() {
    this.setSearchText(this.searchText);
    return this.searchText;
  }
};
__decorateClass([
  Prop({ type: String, default: "" })
], FaqHeaderComponent.prototype, "value", 2);
__decorateClass([
  faqModule.Action("setSearchText")
], FaqHeaderComponent.prototype, "setSearchText", 2);
__decorateClass([
  Watch("searchText", { immediate: true })
], FaqHeaderComponent.prototype, "updateSearchText", 1);
FaqHeaderComponent = __decorateClass([
  Component({
    name: "faq-header",
    store
  })
], FaqHeaderComponent);

export default FaqHeaderComponent;
